import React from "react";
import DataGrid, {
  Column,
  Selection,
  FilterRow,
  Paging,
  Pager,
  Toolbar,
  Item,
  RequiredRule,
  Editing,
  Form,
  Popup,
  Label,
  // SearchPanel,
} from "devextreme-react/data-grid";
import HtmlEditor, { MediaResizing } from "devextreme-react/html-editor";
import { Button } from "devextreme-react";
import { formatMessage } from "devextreme/localization";
import { useScreenSize } from "../../../../utils/media-query";

export default function AnnouncementTableList({
  dataSource,
  dataGrid,
  middleware,
  renderActions,
}) {
  const [body, setBody] = React.useState("");
  const formData = React.useRef({});
  const { isXSmall, isSmall } = useScreenSize();
  return (
    <DataGrid
      id="gridContainer"
      height={document.documentElement.offsetHeight - 189}
      dataSource={dataSource}
      showBorders={true}
      showRowLines={true}
      hoverStateEnabled={true}
      width="100%"
      columnResizingMode="widget"
      rowAlternationEnabled={true}
      ref={(e) => {
        dataGrid.current = e;
      }}
      columnAutoWidth={true}
      allowColumnResizing={true}
      alignment="center"
      onRowInserting={(e) => {
        setBody("");
        e.data.Message = formData.current.Message;
      }}
      onRowUpdating={(e) => {
        e.newData.Message = formData.current.Message;
      }}
      onEditingStart={(e) => {
        setBody(e.data.Message);
        formData.current.Message = e.data.Message;
      }}
    >
      <Selection mode="single" />
      {/* <SearchPanel
        visible={true}
        width={240}
        className="datagrid-toolbar-search-panel"
        placeholder={formatMessage("search")}
      /> */}
      <Editing
        mode="popup"
        useIcons={true}
        allowUpdating={middleware && middleware.WriteState}
        allowAdding={middleware && middleware.CreateState}
        allowDeleting={middleware && middleware.DeleteState}
      >
        <Popup
          title={formatMessage("AddAnnouncement")}
          showTitle={true}
          width={1100}
          height={725}
        />
        <Form>
          <Item itemType="group" colSpan={2}>
            <Item dataField="Subject">
              <Label text={formatMessage("Subject")} />
            </Item>
          </Item>

          <Item itemType="group" colSpan={2}>
            <Item dataField="Message">
              <Label text={formatMessage("Message")} />
              <HtmlEditor
                height={320}
                valueType={"html"}
                onValueChanged={(e) => (formData.current.Message = e.value)}
                defaultValue={body}
              >
                <MediaResizing enabled={true} />
                <Toolbar multiline={true}>
                  <Item name="undo" />
                  <Item name="redo" />
                  <Item name="separator" />
                  <Item
                    name="size"
                    acceptedValues={[
                      "8pt",
                      "10pt",
                      "12pt",
                      "14pt",
                      "18pt",
                      "24pt",
                      "36pt",
                    ]}
                  />
                  <Item
                    name="font"
                    acceptedValues={[
                      "Arial",
                      "Courier New",
                      "Georgia",
                      "Impact",
                      "Lucida Console",
                      "Tahoma",
                      "Times New Roman",
                      "Verdana",
                    ]}
                  />
                  <Item name="separator" />
                  <Item name="bold" />
                  <Item name="italic" />
                  <Item name="strike" />
                  <Item name="underline" />
                  <Item name="separator" />
                  <Item name="alignLeft" />
                  <Item name="alignCenter" />
                  <Item name="alignRight" />
                  <Item name="alignJustify" />
                  <Item name="separator" />
                  <Item name="orderedList" />
                  <Item name="bulletList" />
                  <Item name="separator" />
                  <Item name="header" acceptedValues={[false, 1, 2, 3, 4, 5]} />
                  <Item name="separator" />
                  <Item name="color" />
                  <Item name="background" />
                  <Item name="separator" />
                  <Item name="link" />
                  <Item name="image" />
                  <Item name="separator" />
                  <Item name="clear" />
                  <Item name="codeBlock" />
                  <Item name="blockquote" />
                  <Item name="separator" />
                  <Item name="insertTable" />
                  <Item name="deleteTable" />
                  <Item name="insertRowAbove" />
                  <Item name="insertRowBelow" />
                  <Item name="deleteRow" />
                  <Item name="insertColumnLeft" />
                  <Item name="insertColumnRight" />
                  <Item name="deleteColumn" />
                </Toolbar>
              </HtmlEditor>
            </Item>
            <Item dataField="Link">
              <Label text={formatMessage("Link")} />
            </Item>
            <Item dataField="IsHighImportant">
              <Label text={formatMessage("IsHighImportant")} />
            </Item>
            <Item dataField="Remarks" editorType="dxTextArea">
              <Label text={formatMessage("Remarks")} />
            </Item>
          </Item>
        </Form>
      </Editing>
      <FilterRow visible={true} />
      <Paging defaultPageSize={10} />

      <Pager
        showPageSizeSelector={true}
        allowedPageSizes={[10, 20, 50, 100]}
        showInfo={true}
        visible={true}
      />

      <Column type="buttons">
        <Button name="delete" />
        <Button name="save" />
        <Button name="cancel" />
      </Column>
      <Column
        caption={formatMessage("Subject")}
        dataField="Subject"
        dataType="string"
        allowSearch={true}
        hidingPriority={isXSmall || isSmall ? 4 : false}
      >
        <RequiredRule />
      </Column>
      <Column
        caption={formatMessage("Link")}
        dataField="Link"
        dataType="string"
        allowSearch={true}
        width={"200px"}
        hidingPriority={isXSmall || isSmall ? 4 : false}
      >
        <RequiredRule />
      </Column>
      <Column
        caption={formatMessage("PublishedBy")}
        dataField="PublishedBy"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 4 : false}
      />
      <Column
        caption={formatMessage("PublishedDate")}
        dataField="PublishedDate"
        dataType="date"
        format="dd/MM/yyyy"
        hidingPriority={isXSmall || isSmall ? 4 : false}
      />
      <Column
        caption={formatMessage("IsHighImportant")}
        dataField="IsHighImportant"
        dataType="boolean"
        hidingPriority={isXSmall || isSmall ? 4 : false}
      />
      <Column
        caption={formatMessage("Remarks")}
        dataField="Remarks"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 4 : false}
      />
      <Column
        caption={formatMessage("IsPublish")}
        dataField="IsPublish"
        alignment="center"
        hidingPriority={isXSmall || isSmall ? 4 : false}
        // cellRender={(e) => renderCheckboxActive(e)}
      />

      <Column
        caption={formatMessage("Action")}
        cellRender={renderActions}
        alignment="center"
        hidingPriority={isXSmall ? 15 : false}
      />
      <Toolbar>
        <Item
          location="after"
          locateInMenu={isXSmall || isSmall ? "always" : "auto"}
          cssClass={"datagrid-toolbar-actions-dropdown"}
        >
          <Button
            icon="revert"
            text={formatMessage("Refresh")}
            onClick={() => dataGrid.current.instance.refresh()}
            name="revertButton"
            className="mr-1"
          />
          {middleware && middleware.CreateState && (
            <Button
              icon="plus"
              text={formatMessage("AddAnnouncement")}
              onClick={() => dataGrid.current.instance.addRow()}
              name="add"
              className="mr-1"
              stylingMode="outlined"
              type="default"
            />
          )}
        </Item>
      </Toolbar>
    </DataGrid>
  );
}
